import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewOrigen = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'origen',
        name: 'Origen',
        component: ViewOrigen,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
